// @ts-nocheck
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, Box, Divider, Typography, Button, Icon } from '@material-ui/core';
import { StringUtils } from '../../../../common/utils';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  title: {
    display: 'flex',
    flex: 1,
    marginBottom: theme.spacing(2),
  },
  content: {
    height: '100%',
    marginTop: theme.spacing(2),
  },
  titleBox: {
    display: 'flex',
    flex: '1',
    '& $button': {
      display: 'flex',
      marginBottom: theme.spacing(2),
    },
  },
}));

function MultiVoucherSection(props) {
  const classes = useStyles();
  const [t] = useTranslation();

  const { id, title, className, children, seriesId, onDownloadVouchers } = props;

  return (
    <Box id={StringUtils.makeId(id, 'section')} className={clsx(classes.container, className)}>
      <Box className={classes.titleBox}>
        <Typography id={StringUtils.makeId(id, 'title')} variant="h6" className={classes.title}>
          {title}
        </Typography>
        <Button
          color="primary"
          variant="outlined"
          onClick={() => onDownloadVouchers(seriesId)}
          startIcon={<Icon>download</Icon>}
          className={classes.downloadButton}
        >
          {t('common.download')}
        </Button>
      </Box>
      <Divider />
      <Box id={StringUtils.makeId(id, 'content')} className={classes.content}>
        {children}
      </Box>
    </Box>
  );
}

MultiVoucherSection.defaultProps = {
  id: undefined,
  className: undefined,
  seriesId: undefined,
  actiosDisabled: undefined,
  onDownloadVouchers: undefined,
};

MultiVoucherSection.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  seriesId: PropTypes.number.isRequired,
  actiosDisabled: PropTypes.func.isRequired,
  onDownloadVouchers: PropTypes.func.isRequired,
};

export default MultiVoucherSection;
